/* Opuliss campaign funnel, round 37, 2026-09-27.
   Native scrolling only: nothing here takes over the scroll. It reads scroll positions to drive held scenes,
   the chapter rail and the pinned bar, and it switches the chosen formula with a soft crossfade. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__ocp) return;
    root.__ocp = true;
    var fid = root.id;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wide = window.matchMedia('(min-width: 834px)');
    /* A texture film has a smaller phone file where one was made, and the scroll film for a computer. */
    function filmSrc(v) { return (!wide.matches && v.getAttribute('data-src-phone')) || v.getAttribute('data-src'); }
    var data = { products: [] };
    try { data = JSON.parse(root.querySelector('[data-ocp-data]').textContent); } catch (e) {}
    var P = data.products || [];
    var cur = Number(root.getAttribute('data-ocp-cur')) || 0;
    var routine = 0; /* 0 nothing added here yet, 1 her formula added, 2 both added */

    /* The store header: the rail and every held scene sit under it while it shows. */
    var head = document.querySelector('.skm-header-wrap, .obm-header-wrap, sticky-header, .header-wrapper');
    function headBottom() {
      if (!head) return 0;
      var r = head.getBoundingClientRect();
      var pos = getComputedStyle(head).position;
      if (pos !== 'fixed' && pos !== 'sticky') return 0;
      return r.bottom > 0 ? Math.round(r.bottom) : 0;
    }
    root.style.setProperty('--ocp-head0', (head ? Math.round(head.getBoundingClientRect().height) : 0) + 'px');

    /* ---------- Choosing a formula ---------- */
    function setText(sel, txt) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
    function apply(i) {
      var p = P[i]; if (!p) return;
      cur = i;
      root.setAttribute('data-ocp-cur', i);
      root.querySelectorAll('[data-ocp-p]').forEach(function (el) { el.classList.toggle('is-cur', el.getAttribute('data-ocp-p') === String(i)); });
      /* Names outside the per-formula panes */
      root.querySelectorAll('[data-ocp-name]').forEach(function (el) { if (!el.closest('[data-ocp-p]')) el.textContent = p.title; });
      root.querySelectorAll('[data-ocp-select]').forEach(function (s) { s.value = String(i); });
      root.querySelectorAll('[data-ocp-add-cur]').forEach(function (b) { b.setAttribute('data-ocp-add', p.variant); b.disabled = !p.available; });
      root.querySelectorAll('[data-ocp-tile]').forEach(function (t) { t.classList.toggle('is-hers', t.getAttribute('data-ocp-tile') === String(i)); });
      var bi = root.querySelector('[data-ocp-bar-img] img'); if (bi && p.img) bi.src = p.img;
      setText('[data-ocp-bar-size]', p.size || '');
      routine = 0;
      paintBar();
      /* A chosen formula's texture scene starts again, and its ingredient panels start on the first. */
      root.querySelectorAll('[data-ocp-p="' + i + '"] [data-ocp-texmedia]').forEach(function (m) { m.classList.remove('is-in'); });
      if (texIO) root.querySelectorAll('[data-ocp-p="' + i + '"] [data-ocp-texmedia]').forEach(function (m) { texIO.observe(m); });
      if (ingIO) root.querySelectorAll('[data-ocp-p="' + i + '"] [data-ocp-ing]').forEach(function (li) { ingIO.observe(li); });
      root.dispatchEvent(new CustomEvent('ocp:choose', { detail: { i: i } }));
      requestAnimationFrame(frame);
    }
    function choose(i, byHand) {
      i = Number(i);
      if (!P[i] || i === cur && root.__ocpReady) return;
      if (byHand) {
        try { var u = new URL(window.location.href); u.searchParams.set('formula', i); history.replaceState(null, '', u); } catch (e) {}
      }
      if (reduce || !root.__ocpReady) { apply(i); return; }
      root.classList.add('is-fading');
      setTimeout(function () { apply(i); requestAnimationFrame(function () { root.classList.remove('is-fading'); }); }, 240);
    }

    root.querySelectorAll('[data-ocp-select]').forEach(function (s) {
      s.addEventListener('change', function () { choose(s.value, true); });
    });

    /* ---------- Add to bag, staying on the page ---------- */
    function status(btn, msg) {
      var box = btn.closest('.ocp-tile, .ocp-pair__buy, .ocp-open__text, [data-ocp-status-box]') || root;
      var s = box.querySelector('[data-ocp-status]'); if (s) s.textContent = msg;
    }
    function openDrawer(resp) {
      var cart = document.querySelector('cart-drawer'), box = document.querySelector('#CartDrawer');
      var html = resp && resp.sections && resp.sections['cart-drawer'];
      if (!cart || !box || !html || typeof cart.toggleDrawerClasses !== 'function') return false;
      try {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        if (fresh) box.innerHTML = fresh.innerHTML;
        if (!cart.isOpen) cart.toggleDrawerClasses();
        return true;
      } catch (e) { return false; }
    }
    function add(btn, ids) {
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), sections: 'cart-drawer', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (resp) {
        btn.removeAttribute('aria-busy');
        if (resp && resp.status) { status(btn, resp.description || resp.message || 'That could not be added.'); return; }
        status(btn, 'Added to your bag.');
        var p = P[cur], pr = p && p.pair;
        var strs = ids.map(String);
        var hasMine = p && strs.indexOf(String(p.variant)) > -1;
        var hasPair = pr && strs.indexOf(String(pr.variant)) > -1;
        if (hasMine && hasPair) routine = 2;
        else if (hasMine) routine = Math.max(routine, pr ? 1 : 0);
        else if (hasPair && routine === 1) routine = 2;
        paintBar();
        root.dispatchEvent(new CustomEvent('ocp:added', { detail: { ids: ids, routine: routine } }));
        if (btn.hasAttribute('data-ocp-bar-btn')) { /* the bar says it, the drawer can wait */ } else { openDrawer(resp); }
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ocp', cartData: resp }); } catch (e) {} }
      }).catch(function () { btn.removeAttribute('aria-busy'); status(btn, 'That did not go through. Please try again.'); });
    }
    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-ocp-pick]');
      if (pick) {
        e.preventDefault();
        choose(pick.getAttribute('data-ocp-pick'), true);
        var top = document.getElementById(fid + '-top');
        if (top) setTimeout(function () { top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, reduce ? 0 : 260);
        return;
      }
      var bar = e.target.closest('[data-ocp-bar-btn]');
      if (bar && bar.getAttribute('data-ocp-mode') === 'view') { window.location.href = '/cart'; return; }
      if (bar && bar.getAttribute('data-ocp-mode') === 'pair') { e.preventDefault(); add(bar, [bar.getAttribute('data-ocp-add')]); return; }
      var one = e.target.closest('[data-ocp-add]'), two = e.target.closest('[data-ocp-add-pair]');
      if (one) { e.preventDefault(); add(one, [one.getAttribute('data-ocp-add')]); }
      else if (two) { e.preventDefault(); add(two, two.getAttribute('data-ocp-add-pair').split(',')); }
    });

    /* ---------- The pinned bar ---------- */
    var barEl = root.querySelector('[data-ocp-bar]'), barBtn = root.querySelector('[data-ocp-bar-btn]');
    var barTop = root.querySelector('[data-ocp-bar-top]'), barName = root.querySelector('[data-ocp-bar-name]'), barPrice = root.querySelector('[data-ocp-bar-price]');
    var collName = barTop ? barTop.textContent : '';
    function paintBar() {
      var p = P[cur]; if (!p || !barEl) return;
      var pr = p.pair;
      barEl.classList.toggle('is-routine', routine > 0);
      if (routine === 1 && pr) {
        barTop.textContent = 'Your routine: 1 of 2';
        barName.textContent = 'Add the ' + pr.noun + ', ' + pr.title;
        barPrice.textContent = pr.total;
        setText('[data-ocp-bar-size]', 'for both');
        barBtn.textContent = 'Add the ' + pr.noun + ', ' + pr.price;
        barBtn.setAttribute('data-ocp-mode', 'pair');
        barBtn.setAttribute('data-ocp-add', pr.variant);
        barBtn.disabled = !pr.available;
      } else if (routine === 2 && pr) {
        barTop.textContent = 'Your routine: 2 of 2';
        barName.textContent = p.title + ' and ' + pr.title;
        barPrice.textContent = pr.total;
        setText('[data-ocp-bar-size]', 'for both');
        barBtn.textContent = 'View your bag';
        barBtn.setAttribute('data-ocp-mode', 'view');
        barBtn.disabled = false;
      } else {
        barTop.textContent = collName;
        barName.textContent = p.title;
        barPrice.textContent = p.price;
        setText('[data-ocp-bar-size]', p.size || '');
        barBtn.textContent = 'Add to bag';
        barBtn.setAttribute('data-ocp-mode', 'one');
        barBtn.setAttribute('data-ocp-add', p.variant);
        barBtn.disabled = !p.available;
      }
    }

    /* ---------- Chapters, rail, held scenes: one frame per scroll ---------- */
    var rail = root.querySelector('[data-ocp-rail]');
    var heroAdd = root.querySelector('[data-ocp-hero-add]');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-ocp-ch]'));
    var chapters = links.map(function (a) { return root.querySelector('[data-ocp-chapter="' + a.getAttribute('data-ocp-ch') + '"]'); });
    var nowN = root.querySelector('[data-ocp-now-n]'), nowL = root.querySelector('[data-ocp-now]');
    var scene = root.querySelector('[data-ocp-scene]');
    var heroImgs = root.querySelectorAll('.ocp-open__img');
    var ticking = false;
    function frame() {
      ticking = false;
      var hb = headBottom();
      root.style.setProperty('--ocp-head', hb + 'px');
      var railH = rail ? rail.getBoundingClientRect().height : 0;
      var line = hb + railH + 4;

      /* The bar shows once the opening's Add to bag has gone up under the header, so a price and a button are always on screen. */
      if (barEl && heroAdd) {
        var on = heroAdd.getBoundingClientRect().bottom < line;
        if (on !== barEl.classList.contains('is-on')) {
          barEl.classList.toggle('is-on', on);
          barEl.setAttribute('aria-hidden', on ? 'false' : 'true');
          barEl.querySelectorAll('button, select').forEach(function (b) { b.tabIndex = on ? 0 : -1; });
        }
      }

      /* Which chapter she is reading, and how far through the five she is. */
      var active = -1, vh = window.innerHeight;
      chapters.forEach(function (c, k) { if (c && c.getBoundingClientRect().top <= line + vh * 0.35) active = k; });
      var first = chapters[0], last = chapters[chapters.length - 1];
      if (active > -1 && last && last.getBoundingClientRect().bottom < line) active = -2; /* past the last chapter */
      links.forEach(function (a, k) {
        a.setAttribute('aria-current', k === active ? 'true' : 'false');
        a.classList.toggle('is-past', active === -2 || k < active);
      });
      if (nowN && active >= 0) { nowN.textContent = String(active + 1); nowL.textContent = links[active].textContent.replace(/^\s*\d+\s*/, '').trim(); }
      if (first && last && rail) {
        var a0 = first.getBoundingClientRect().top + window.scrollY - line;
        var a1 = last.getBoundingClientRect().bottom + window.scrollY - line - vh * 0.5;
        var prog = Math.min(1, Math.max(0, (window.scrollY - a0) / Math.max(1, a1 - a0)));
        rail.style.setProperty('--ocp-prog', prog.toFixed(4));
      }

      /* The texture scene: 0 as it arrives under the rail, 1 as it lets go. */
      if (scene && wide.matches && !reduce) {
        var r = scene.getBoundingClientRect();
        var span = r.height - (vh - line);
        var t = span > 0 ? Math.min(1, Math.max(0, (line - r.top) / span)) : 0;
        scene.style.setProperty('--ocp-p', t.toFixed(4));
        var film = scene.querySelector('[data-ocp-p="' + cur + '"] [data-ocp-scrub]');
        if (film && film.readyState >= 1 && film.duration) {
          var want = t * (film.duration - 0.05);
          if (Math.abs(film.currentTime - want) > 0.03) { try { film.currentTime = want; } catch (e) {} }
        }
      } else if (scene) {
        scene.style.removeProperty('--ocp-p');
      }

      /* The opening packshot drifts up a little slower than the page. */
      if (!reduce && wide.matches) {
        var y = Math.min(window.scrollY, vh);
        heroImgs.forEach(function (im) { im.style.setProperty('--ocp-par', (y * 0.12).toFixed(1) + 'px'); });
      }
    }
    function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    if (head) head.addEventListener('transitionend', kick);

    /* Chapter links and every Next line move with a smooth native scroll that stops under the rail. */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-ocp-jump]'); if (!a) return;
      var id = (a.getAttribute('href') || '').replace(/^#/, ''); var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    /* ---------- What arrives on screen ---------- */
    var texIO = null, ingIO = null;
    if ('IntersectionObserver' in window) {
      /* On a phone, a texture still pushes in once, and a texture film plays once. */
      texIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var m = en.target; texIO.unobserve(m);
          if (reduce) return;
          m.classList.add('is-in');
          var v = m.querySelector('[data-ocp-scrub]');
          if (v && !v.src && v.getAttribute('data-src')) { v.src = filmSrc(v); v.preload = 'auto'; }
          if (v && !wide.matches) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        });
      }, { threshold: 0.35 });
      root.querySelectorAll('.is-cur [data-ocp-texmedia]').forEach(function (m) { texIO.observe(m); });

      /* A texture film for the scroll is fetched as the scene nears, so the scroll can drive it. */
      var nearIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || reduce) return; /* with less motion the still poster is the whole scene */
          root.querySelectorAll('[data-ocp-scrub]').forEach(function (v) {
            if (!v.closest('.is-cur') || v.src) return;
            v.src = filmSrc(v); v.preload = 'auto';
            v.addEventListener('loadedmetadata', kick, { once: true });
          });
        });
      }, { rootMargin: '60% 0px' });
      if (scene && root.querySelector('[data-ocp-scrub]')) nearIO.observe(scene);

      /* On a computer the ingredient panel in the middle of the screen is the one in focus. */
      ingIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var li = en.target, list = li.parentElement;
          list.querySelectorAll('[data-ocp-ing]').forEach(function (x) { x.classList.toggle('is-on', x === li); });
          var pane = li.closest('[data-ocp-p]'); var n = pane && pane.querySelector('[data-ocp-ingnow]');
          if (n) n.textContent = li.getAttribute('data-ocp-ing');
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      root.querySelectorAll('[data-ocp-ing]').forEach(function (li) { ingIO.observe(li); });

      /* Chapters rise as they arrive. */
      var rise = root.querySelectorAll('[data-ocp-rise]');
      if (reduce) { rise.forEach(function (el) { el.classList.add('is-in'); }); }
      else {
        var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
        rise.forEach(function (el) { io.observe(el); });
      }

      /* The how-to film loads only when she scrolls near it, only on a computer, and plays while on screen. */
      var films = root.querySelectorAll('[data-ocp-lazyfilm]');
      /* The poster is a computer-only picture too: a phone never shows this film, so it never fetches its poster. */
      function posters() { if (!wide.matches) return; films.forEach(function (v) { var ps = v.getAttribute('data-poster'); if (ps && !v.getAttribute('poster')) v.setAttribute('poster', ps); }); }
      posters();
      if (wide.addEventListener) wide.addEventListener('change', posters);
      var loadIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || !wide.matches) return;
          var v = en.target; loadIO.unobserve(v);
          if (!v.src) { v.src = v.getAttribute('data-src'); }
        });
      }, { rootMargin: '50% 0px' });
      var playIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && wide.matches && !reduce && !v.dataset.userPaused && v.src) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.3 });
      films.forEach(function (v) { loadIO.observe(v); playIO.observe(v); v.addEventListener('loadeddata', function () { if (v.getBoundingClientRect().top < window.innerHeight && !reduce && !v.dataset.userPaused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }); });
    } else {
      root.querySelectorAll('[data-ocp-rise]').forEach(function (el) { el.classList.add('is-in'); });
    }
    root.querySelectorAll('[data-ocp-pause]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video'); if (!v) return;
        if (v.paused) { delete v.dataset.userPaused; if (!v.src) v.src = v.getAttribute('data-src'); v.play(); btn.textContent = 'II'; btn.setAttribute('aria-label', 'Pause the film'); }
        else { v.dataset.userPaused = '1'; v.pause(); btn.textContent = '▶'; btn.setAttribute('aria-label', 'Play the film'); }
      });
    });

    /* On a phone each ingredient is a card that opens on a tap. */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ocp-ingtoggle]'); if (!t || wide.matches) return;
      var li = t.closest('[data-ocp-ing]'); var open = !li.classList.contains('is-open');
      li.classList.toggle('is-open', open); t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    function syncToggles() {
      root.querySelectorAll('[data-ocp-ingtoggle]').forEach(function (t) {
        if (wide.matches) { t.setAttribute('aria-expanded', 'true'); t.tabIndex = -1; }
        else { t.setAttribute('aria-expanded', t.closest('[data-ocp-ing]').classList.contains('is-open') ? 'true' : 'false'); t.removeAttribute('tabindex'); }
      });
    }
    if (wide.addEventListener) wide.addEventListener('change', function () { syncToggles(); kick(); });
    syncToggles();

    /* The collection story tabs. */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ocp-tab]'));
    function pickTab(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        var pnl = document.getElementById(x.getAttribute('aria-controls')); if (pnl) pnl.hidden = !on;
      });
      if (focus) t.focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { pickTab(t); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? k + 1 : e.key === 'ArrowLeft' ? k - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
        if (j === null) return; e.preventDefault(); pickTab(tabs[(j + tabs.length) % tabs.length], true);
      });
    });
    if (tabs.length && !tabs.some(function (t) { return t.getAttribute('aria-selected') === 'true'; })) pickTab(tabs[0]);

    /* Start: the formula the address named (already painted by the early script), then drop that early style. */
    apply(cur);
    var early = document.getElementById(fid + '-early'); if (early) early.remove();
    root.__ocpReady = true;
    frame();
  }

  function boot() { document.querySelectorAll('[data-ocp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
